import {
  initializeApp
} from 'firebase/app'
import {
  getAuth,
  onAuthStateChanged
} from 'firebase/auth'
import config from '../firebase.config'
import store from '../store'
import {
  fire
} from '@/utils/logger'

initializeApp(config)
const auth = getAuth()

// export default () => {
// return new Promise((resolve) => {
//   onAuthStateChanged(auth, (user) => {
export default function initAuth() {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        store.commit("setUser", {
          name: user.displayName,
          mail: user.email,
          image: user.photoURL,
          uid: user.uid,
        });
        console.log("ログインしました");
        // this.sendUserData(user.displayName, user.email);
        store.dispatch("sendUserData", {
          name: user.displayName,
          uid: user.uid
        });
        // セッション内でまだ送っていなければ login_result を1回だけ送信
        if (!sessionStorage.getItem('sent_login_result')) {
          fire('login_result', {
            provider: 'google',
            ok: true,
            uid: user.uid,
          });
          sessionStorage.setItem('sent_login_result', '1');
        }
      } else {
        store.commit("setUser", {
          name: "guest",
          uid: "guest"
        });
        console.log("ログアウトしました");
      }
      resolve();
    });
  })
}